/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, SetStateAction, useEffect, useState } from "react";
export interface IDataSource<T> {
    data: T[];
    loading: boolean;
    setData: Dispatch<SetStateAction<T[]>>;
    updateData: () => any;
    fetch: () => Promise<T[]>;
}

export function useDatasource<T>(
    fetchFn: () => Promise<T[]>,
    deps: any[] = []
): IDataSource<T> {
    const [trigger, setTrigger] = useState<boolean>(false);
    const [data, setData] = useState<T[]>([]);
    const [loading, setLoading] = useState(true);
    async function fetch() {
        setLoading(true);
        try {
            const newData = await fetchFn();
            setData(newData);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetch();
    }, [...deps, trigger]);
    return {
        data,
        loading,
        setData,
        fetch: fetchFn,
        updateData: () => setTrigger(!trigger),
    } as IDataSource<T>;
}
